<template>
  <form @submit.prevent="handleSubmit">
    <div class="mb-2">
      <v-input
        required
        :placeholder="$t('components.auth.createAccountForm.namePlaceholder')"
        v-model="name"
        type="text"
        name="name"
        autofocus
      ></v-input>
    </div>
    <div class="mb-2">
      <v-input
        required
        :placeholder="$t('components.auth.createAccountForm.emailPlaceholder')"
        disabled
        :value="email"
        type="email"
        name="email"
      ></v-input>
    </div>
    <div class="mb-2">
      <v-input
        required
        :placeholder="
          $t('components.auth.createAccountForm.passwordPlaceholder')
        "
        v-model="password"
        type="password"
        name="password"
      ></v-input>
    </div>
    <div v-if="shouldShowLegal" class="mb-2 py-1">
      <v-switch
        class="d-flex"
        data-cy="app-legal-terms"
        required
        v-model="hasAcceptedLegal"
      >
        {{
          $t("components.auth.createAccountForm.tosHeading", {
            appName: appName
          })
        }}
        <a
          v-if="app.legal_terms_and_conditions_url"
          class="text-underline font-weight-bold"
          target="_blank"
          :href="app.legal_terms_and_conditions_url"
          >{{ $t("components.auth.createAccountForm.tos") }}</a
        >
        <template
          v-if="
            app.legal_terms_and_conditions_url && app.legal_privacy_policy_url
          "
        >
          {{ $t("components.auth.createAccountForm.and") }}
        </template>
        <a
          v-if="app.legal_privacy_policy_url"
          class="text-underline font-weight-bold"
          target="_blank"
          :href="app.legal_privacy_policy_url"
          >{{ $t("components.auth.createAccountForm.privacyPolicy") }}</a
        >
      </v-switch>
    </div>
    <div class="d-flex align-items-center">
      <v-button
        round
        secondary
        class="mr-2"
        type="button"
        @click.prevent="() => $emit('back')"
      >
        <v-icon icon="arrow_back"></v-icon>
      </v-button>
      <v-button
        :is-loading="isLoading"
        :disabled="shouldShowLegal ? !hasAcceptedLegal : false"
        block
        type="submit"
      >
        {{ $t("components.auth.createAccountForm.cta") }}
      </v-button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex"

import vInput from "@/components/forms/vInput"
import vSwitch from "@/components/forms/vSwitch"

export default {
  components: {
    vInput,
    vSwitch
  },

  props: {
    email: { type: String, required: true }
  },

  data() {
    return {
      name: "",
      password: "",
      isLoading: false,
      hasAcceptedLegal: false
    }
  },

  mounted() {
    if (this.email.length === 0) this.$emit("back")
  },

  computed: {
    ...mapGetters(["appName", "app"]),

    shouldShowLegal() {
      return !!(
        this.app.legal_requires_acceptance &&
        (this.app.legal_terms_and_conditions_url ||
          this.app.legal_privacy_policy_url)
      )
    }
  },

  methods: {
    handleSubmit() {
      this.isLoading = true

      if (this.password.length <= 6) {
        this.isLoading = false
        this.$notify(
          this.$t("components.auth.createAccountForm.passwordTooShort")
        )
      } else if (this.name.length <= 2) {
        this.isLoading = false
        this.$notify(this.$t("components.auth.createAccountForm.nameTooShort"))
      } else {
        this.$emit("submit", {
          name: this.name,
          email: this.email,
          password: this.password
        })
        setTimeout(() => {
          this.isLoading = false
        }, 1500)
      }
    }
  }
}
</script>
